import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
} from '../@types';

export type TCRBItem4 = {
    tanks: TCRBItem4Tank[];
};

export type TCRBItem4Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem4P1 = {
    destinationTanks: TCRBItem4Tank[];
};

export type TCRBItem4P2 = {
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem4P3 = {
    totalQuantityTransferred: number;
};

export type TCRBItem5 = {
    wereTanksEmptied: boolean;
};

export type TCRBB1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBB;
        item4: TCRBItem4;
        item4P1: TCRBItem4P1;
        item4P2: TCRBItem4P2;
        item4P3: TCRBItem4P3;
        item5: TCRBItem5;
    };

export type TCRBB = TCRBB1;

const CRBB_DEFAULTS: {
    B: TCRBB1;
} = {
    B: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item4: {
            tanks: [],
        },
        item4P1: {
            destinationTanks: [],
        },
        item4P2: {
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
        },
        item4P3: {
            totalQuantityTransferred: 0,
        },
        item5: {
            wereTanksEmptied: false,
        },
        recordCode: ECRBRecordCode.CRBB,
    },
};

export { CRBB_DEFAULTS };
